import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=4904d42d&scoped=true&lang=pug&"
import script from "./AddressBox.vue?vue&type=script&lang=js&"
export * from "./AddressBox.vue?vue&type=script&lang=js&"
import style0 from "./AddressBox.vue?vue&type=style&index=0&id=4904d42d&scoped=true&lang=css&"
import style1 from "./AddressBox.vue?vue&type=style&index=1&lang=css&"
import style2 from "./AddressBox.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904d42d",
  null
  
)

component.options.__file = "AddressBox.vue"
export default component.exports